<template>
    <v-panel
        v-model="popStatus"
        :mask-closable="false"
        :width="900"
        @close="handlerCancel"
        class="box-pack-panel"
        title="选择图文消息"
    >
        <div class="waterfall-add-module">
            <WaterfallAdd :show="popStatus" />
        </div>
        <div class="waterfall-pop-body">
            <div class="waterfall-container">
                <WaterfallPicker
                    :list="list"
                    :selected="selected"
                    @change="onChange"
                />
            </div>
            <ReplyLoading v-show="loading" />
            <ReplyPagination
                :total="totalPage"
                :count="count"
                :text="paginationExtraText"
                @change="onPageChange"
            />
        </div>
        <div class="img-picker-operator">
            <v-button
                :disabled="!selected.id"
                @click="handlerOk"
                style="margin-right: 15px;"
                size="large"
                kind="primary"
            >
                确定
            </v-button>
            <v-button
                @click="handlerCancel"
                size="large"
            >
                取消
            </v-button>
        </div>
    </v-panel>
</template>

<script>
import axios from 'axios';
import WaterfallAdd from './waterfall-add';
import ReplyPagination from '../reply-pop/reply-pagination';
import ReplyLoading from '../reply-pop/reply-loading';
import WaterfallPicker from './waterfall-picker';

const imgTxtMaterialUrl = '/mp/rest/imgTxtMaterial';
const imgTxtType = 0;

export default {
    components: {
        WaterfallAdd,
        ReplyPagination,
        ReplyLoading,
        WaterfallPicker,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            popStatus: false,
            list: [],
            loading: false,
            selected: this.value,
            currentPage: 1,
            totalPage: 0,
            count: 30, // 每页展示个数
        };
    },
    computed: {
        paginationExtraText() {
            return `共 ${this.totalPage} 条图文消息`;
        },
    },
    watch: {
        show(newValue) {
            if (newValue && !this.list.length) {
                this.fetchList(this.currentPage);
            }
            this.popStatus = newValue;
        },
        currentPage(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.fetchList(newValue);
            }
        },
        value(newValue) {
            this.selected = newValue;
        },
    },
    methods: {
        fetchList(page) {
            this.loading = true;
            this.list = [];

            axios({
                method: 'get',
                url: imgTxtMaterialUrl,
                params: {
                    index: page,
                    count: this.count,
                    imgTxtType,
                },
            })
                .then((res) => {
                    if (res) {
                        this.list = res.records || [];
                        this.totalPage = res.total || 0;
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
        closePanel() {
            this.$emit('update:show', false);
        },
        handlerOk() {
            this.$emit('input', this.selected);
            this.closePanel();
        },
        handlerCancel() {
            // 取消时，使用传入的props恢复selected
            this.selected = this.value;
            this.closePanel();
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        onChange(item) {
            this.selected = item.id === this.selected.id ? {} : item;
        },
    },
};
</script>

<style lang="less">
.box-pack-panel {
    z-index: 99999 !important;
}
.waterfall-add-module {
    position: absolute;
    top: 55px;
    right: 20px;
}

.waterfall-pop-body {
    position: absolute;
    top: 80px;
    bottom: 92px;
    right: 0;
    left: 0;
    background-color: #edeff2;

    .waterfall-container {
        position: absolute;
        top: 30px;
        bottom: 40px;
        right: 0;
        left: 0;
    }
}
</style>
